import React, {Component} from 'react';
import classNames from 'classnames';
import * as formatter from "../../utils/formatters"
import * as dataService from '../../service/data-info-chart/requestsUtil'
import {RESTRICTED_ACCOUNTS, WHITOUT_INFORMATION} from "../../utils/constants";
import * as cbu from "../../utils/checkBusinessUnit";

var Loader = require('react-loader');

class RestrictedAccountsTable extends Component {

  constructor(props) {
    super(props)
    this.state = {data: []}
  }

  componentDidMount() {
    dataService.getFetch(RESTRICTED_ACCOUNTS + cbu.checkBusinessUnit(this.props.bu))
      .then((data) => {
        this.setState({data: data, loaded: true});
      });
  }

  render() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    if (this.state.data.length > 0) {
      let rows = this.state.data.map(data => {
        return <tr>
          <td>{data.month}</td>
          <td>{formatter.formatNumber(data.accounts)}</td>
          <td>{formatter.formatNumber(data.accountsR)}</td>
          <td>${formatter.formatNumber(data.amount)}</td>
          <td>{formatter.formatNumber(data.amountR)}</td>
        </tr>
      })

      return (
        <table className={tableClass}>
          <thead>
          <tr>
            <th>Mes</th>
            <th>CUENTAS</th>
            <th>C. RESTRINGIDAS</th>
            <th>MONTOS</th>
            <th>M. RESTRINGIDOS</th>
          </tr>
          </thead>
          <tbody>
          {rows}
          </tbody>
        </table>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }
  }
}

export default RestrictedAccountsTable;



// WEBPACK FOOTER //
// ./src/components/tables/restrictedAccountsTable.js